export const ROUTES = {
  home: '/',
  project: '/projects',
  business: '/businesses',
  impact: '/impacts',
  teamDetail: '/team/:id',
  impactDetail: '/impacts/:id',
  projectDetail: '/projects/:id',
  businessDetail: '/business/:id',
  team: '/team'
}
